import { render, staticRenderFns } from "./AnaliseProduto.vue?vue&type=template&id=6bac92a0&"
import script from "./AnaliseProduto.vue?vue&type=script&lang=js&"
export * from "./AnaliseProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports